export const quantiquestNextContactValidation = (
  contact: ContactFull,
  lastCallContact: Nilable<ContactRefType>,
  _questionnaire: Nullable<CCTaskType>,
  _events: EventDetailWoContact[],
): [boolean, string] => {
  if (contact.id === lastCallContact?.id) {
    return [true, ""];
  }

  const allowedStates = ["Wiedervorlage", "Paket gebucht", "nicht interessiert", "nicht erreichbar"];

  if (contact.status && allowedStates.includes(contact.status.name)) {
    return [true, ""];
  }

  const toolTipText =
    "Bitte rufen Sie diesen Kontakt erst an oder setzen Sie ihn auf eine der folgenden Statusmöglichkeiten: „Wiedervorlage“, „Paket gebucht“, „nicht interessiert“, „nicht erreichbar“";

  return [false, toolTipText];
};
